module.exports = __webpack_public_path__ + "img/backarrow.ba158c3f.svg";